
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import regulationsApi from "@/api/regulations";
    import baseUrl, {imageUrl} from "@/constants";
    @Component({
        name: "standardDetail",
    })
    export default class Home extends Vue {
        title = "公共标准详情";
        type = "";//Look 查看  Add 添加 Edit 编辑 Examine 审核
        mode = "";//Country 国家， Local 地方，Other 其他
        id = 0;
        bodyTitle = '';
        headerTitle = '';
        form = {
            id: '',
            title: '',
            agencyName: '',
            writingDate: '',
            conditions: '',
            enclosure: '',
            type: 0,
            status: 0,
            shareStatus: 0,
            reason: "",
        }
        rules = {
            title: [{required: true, message: '请输入文件标题', trigger: 'blur'}],
            agencyName: [{required: true, message: '请输入行文机关', trigger: 'blur'}],
            writingDate: [{required: true, message: '请选择行文日期', trigger: 'change'}],
            // enclosure: [{required: true, message: '请上传文件', trigger: 'change'}],
        }
        review = {
            failText: '',
            failDialog: false,
        }
        baseUrl = baseUrl
        headers = {Authorization:""}
        fileList = [] as any;
        fullScreen = false;
        private closePage: any;

        created() {
            this.init();
        }
        init(){
            this.type = this.$route.params.type;
            this.mode = this.$route.params.mode;
            this.id = Number(this.$route.params.id);
            if(this.mode === 'Country'){
                this.form.type = 1;
            }else if(this.mode === 'Local'){
                this.form.type = 0;
            }else if(this.mode === 'Other'){
                this.form.type = 2;
            }
            this.createTitle()
            if(this.id){
                this.getDetail();
            }
        }
        hasBtn(mode: string){
            if(mode === 'save'){
                return this.type === 'Add' || this.type === 'Edit';
            }else if(mode === 'submit'){
                return this.type === 'Add' || this.type === 'Edit';
            }else if(mode === 'past'){
                return this.type === 'Examine';
            }
            return false;
        }
        createTitle(){


            let headerTitle = "";
            let bodyTitle = "";
            if(this.type === 'Look'){
                headerTitle = "查看";
            }else if(this.type === 'Add' || this.type === 'Edit'){
                headerTitle = "添加/编辑";
            }else if(this.type === 'Examine'){
                headerTitle = "待审核";
            }
            if(this.mode ==='Country'){
                headerTitle += '国家计量法规政策';
                bodyTitle = '国家计量法规政策';
            }else if(this.mode === 'Local'){
                headerTitle += '地方计量法规政策';
                bodyTitle = '地方计量法规政策';
            }else if(this.mode === 'Other'){
                headerTitle += '其他计量法规政策';
                bodyTitle = '其他计量法规政策';
            }
            this.headerTitle = headerTitle;
            this.bodyTitle = bodyTitle;
        }
        getDetail(){
            this.fullScreen = true;
            regulationsApi.get(this.id).then((r: any) => {
                if(r.data.result === 0){
                    const d = r.data.data;
                    Object.assign(this.form, d);
                    this.form.status = d.status.value;
                    this.form.type = d.type.value;
                    this.form.shareStatus = d.shareStatus.value;
                    if (this.form.enclosure) {
                        this.fileList = [];
                        try {
                            const obj = JSON.parse(this.form.enclosure);
                            if (typeof obj == 'object' && obj) {
                                for (let i = 0; i < obj.length; i++) {
                                    this.fileList.push({name: obj[i].name, url: imageUrl + obj[i].url})
                                }
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    this.fullScreen = false;
                }
            });
        }

        passOrNot(status: number){
            //通过或不通过
            if (status == 3) {
                //不通过，必须有原因
                if (this.review.failText == "") {
                    this.$message.error("请填写不通过原因");
                    return
                }
                this.form.reason = this.review.failText;
            }
            this.onSubmit(status);
        }
        onSubmit(status: number){
            const enclosureList = this.fileList.map((e: any) => {
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl, "")
                }
            })
            this.form.enclosure = enclosureList.length == 0 ? "" : JSON.stringify(enclosureList);
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    this.submit(status);
                    return;
                }
                this.$message.warning("未填写完整信息");
            });
        }
        submit(status: number){
            this.fullScreen = true;
            this.form.status = status;
            regulationsApi.edit(this.form).then((r: any) => {
                this.fullScreen = false;
                if(r.data.result === 0){
                    this.$message.success("保存成功，1秒后返回上一页！");
                    setTimeout(() => {
                        this.closePage()
                    }, 500);
                }
            });
        }
        handleAvatarSuccess(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.fileList.push({name: this.bodyTitle + ".pdf", url: imageUrl + rData})
            }
        }

        handleRemove() {
            this.fileList = [];
        }

        handlePictureCardPreview(file: any) {
            window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl, "") + "&name=" + file.name, '_blank');
        }

        beforeAvatarUpload(file: any) {
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
                this.$message.error('上传图片只能是PDF格式!');
            }
            return (isPDF);
        }

        closeFail() {
            setTimeout(() => {
                this.review.failText = "";
            }, 500)
            this.review.failDialog = false;
        }

    }
